"use strict";
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.ProductEmpty = void 0;
var _icons = require("@ori-ui/icons");
var _presentationComponents = require("@ori/presentation-components");
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _personalProductListEditContext = require("../../../../contexts/personalProductListEditContext");
var _constants = require("./constants");
var _styles = require("./styles");
var _jsxRuntime = require("react/jsx-runtime");
const ProductEmpty = ()=>{
    const { onOpen } = (0, _personalProductListEditContext.usePersonalProductListEditContext)();
    const { getTestId } = (0, _testidGenerator.default)();
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_styles.EmptyContainer, {
        "data-testid": getTestId(_constants.PRODUCT_EMPTY),
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_presentationComponents.ImagePlaceholder, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_styles.StyledIconButton, {
                color: "primary",
                variant: "contained",
                onClick: onOpen,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_icons.Add, {})
            })
        ]
    });
};
exports.ProductEmpty = ProductEmpty;
